import { useCallback, useState } from 'react';

import { useDataChannel } from '@/components/NewUI/SingleRoot';

// Subscribes on the tab's shared consumer. Each subscribeToChannel(UID) call passes its UID to
// `onReceive` with every message after it, so callers can pick out the reply to their request.
// `Data` is the payload shape the caller expects; the socket does not check it.
export const useWebSockets = <Data,>(
  channel: string,
  onReceive: (data: Data, UID?: number) => void
) => {
  const [subscription, setSubscription] = useState<{ UID?: number } | null>(null);
  const status = useDataChannel(channel, subscription && {}, (data) =>
    onReceive(data as Data, subscription?.UID)
  );

  const subscribeToChannel = useCallback((UID?: number) => setSubscription({ UID }), []);
  const unsubscribeFromChannel = useCallback(() => setSubscription(null), []);

  return { subscribeToChannel, unsubscribeFromChannel, socketConnected: status === 'connected' };
};
